module.exports = __webpack_public_path__ + "img/34.0af21d2b.jpg";